import { createI18n } from "vue-i18n"; // Import createI18n from vue-i18n
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import de from "./locales/de.json";

const messages = {
  en,
  fr,
  de,
};

const i18n = createI18n({
  locale: "de", // Default language
  fallbackLocale: "de", // Fallback language
  messages,
});

// Function to change the language
export function changeLanguage(locale) {
  i18n.global.locale = locale; // Update the locale
  localStorage.setItem("language", locale); // Persist the preference
}

export default i18n;
export { i18n };
